
export const getDefaultState = () => {
  return {
    communityCollectionsList: [],
    communityCollectionsListPageOptions: null,
    nextToken: null,
  };
};
export const state = getDefaultState();
